export const normalizeEmployeeState = (employee) => {
    const raw = employee?.employeeState ?? employee?.status ?? employee?.state ?? "";
    const value = typeof raw === "string" ? raw : String(raw || "");
    return value.trim().toLowerCase().replace(/\s+/g, "");
};

export const extractCompanyName = (employee) => {
    const source =
        employee?.workingCompany ??
        employee?.company ??
        employee?.contractCompany ??
        "";
    if (typeof source === "string") {
        const trimmed = source.trim();
        return trimmed.length ? trimmed : "";
    }
    return String(source || "").trim();
};

export const extractEmployeesFromPayload = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.employees)) return payload.employees;
    if (payload.data) {
        if (Array.isArray(payload.data)) return payload.data;
        if (Array.isArray(payload.data.employees)) return payload.data.employees;
    }
    return [];
};